import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtGetBank(params) {
  return request(
    `${BASE_URL}/provider/ams/bank/listBank`,
    METHOD.POST_JSON_ENCRYPT,
    params
  )
}
